module.exports = __webpack_public_path__ + "static/media/kidii.f57f2527.jpg";